import {Component, EventEmitter, Output, OnInit, Input} from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-user-calls-overview',
  templateUrl: './user-calls-overview.component.html',
  styleUrls: ['./user-calls-overview.component.scss'],
  providers: [DatePipe, DecimalPipe],
})
export class UserCallsOverviewComponent implements OnInit {
  @Input() callList: any;
  @Output() closed = new EventEmitter<void>();
  @Output() viewRecord = new EventEmitter<string>();

  record: any;
  columns: any[] = [];
  isLoading = true;

  constructor(
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe
  ) {}

  ngOnInit() {
    this.columns = [
      {
        header: 'Started At',
        field: 'createdAt',
        formatter: (rowData: any) => this.datePipe.transform(rowData.createdAt, 'MMM d, y, HH:mm:ss'),
      },
      { header: 'Scenario', field: 'agentFirstName' },
      {
        header: 'Score',
        field: 'score',
        formatter: (rowData: any) => this.decimalPipe.transform(rowData.score * 100, '1.2-2'),
      },
      {
        header: 'Duration',
        field: 'duration',
        formatter: (rowData: any) => {
          const minutes = Math.floor(rowData.duration / 1000 / 60);
          const seconds = Math.floor((rowData.duration / 1000) % 60);
          return `${minutes} min ${String(seconds).padStart(2, '0')} sec`;
        },
      },
    ];
  }

  view(record: any) {
    this.viewRecord.emit(record.id);
  }

  close() {
    this.closed.emit();
  }
}
